import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { apisso } from "../api";
import { AuthUser } from "../../@types/auth-user";

export function useAuthUserDetails() {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<AuthUser, AxiosError<{ detail: string }>>({
        retry: false,
        enabled: !!token,
        queryKey: ['auth-user', 'details'],
        queryFn: async () => {
            const response = await apisso.get<Array<AuthUser>>(
                `/cidadaos/pro/`, { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data[0];
        }
    });
}
